import React from 'react'
import NavBar from './NavBar'

export default function Header({check, changeTheme}) {
    return (
        <header className="header">
           <NavBar changeTheme={changeTheme} check={check} />
        </header>
    )
}
